import React from "react";
import "./styles.css";
import SelectWithFlags from "../CustomSelectFlags";
import logo from "../../../public/assets/loogo.png";
import logoutIcon from "../../../public/assets/icon/logOut.png";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { googleLogout } from "@react-oauth/google";



function Menu() {
  const [t, i18n] = useTranslation();

  const handleLogout = async () => {
    const accessToken = localStorage.getItem("authToken");
    const provider = localStorage.getItem("provider");

    if (provider === "google") {
      try {
        googleLogout();
      } catch (e) {
        console.error("Google logout failed:", e);
      }
    }

    localStorage.removeItem("authToken");
    localStorage.removeItem("provider");

    try {
      if (accessToken) {
        await axios.post(process.env.BACK_RND_URL+"/auth/logout", {}, {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        });
      }
    } catch (error) {
      console.error("Backend logout failed:", error);
    } finally {
      window.location.href = '/'; 
    }
  };

  return (
    <div className="header">
      <div className="logo-container">
        <img className="logo" src={logo} alt="Logo" />
      </div>
      <div className="header-actions">
        <SelectWithFlags />
        <button className="login-button" onClick={handleLogout}>
          <img className="profileIcon" src={logoutIcon} alt="Logout Icon" />
          <span className="login-button-span">{t("logout")}</span>
        </button>
      </div>
    </div>
  );
}

export { Menu };
